<template>
  <component
    :is="component"
    class="item"
    :class="{ active: isActive }"
    :to="to"
  >
    <icon v-if="iconName" :name="iconName" />
    <span class="infos">{{ label }} <slot name="badge" /></span>
  </component>
</template>
<script lang="ts" setup>
interface Props {
  label: string;
  to?: string;
  iconName?: string;
}

const props = defineProps({
  label: null,
  to: null,
  iconName: null
});

const route = useRoute();

const component = computed(() => {
  if (props.to) {
    return resolveComponent('NuxtLink');
  }
  return 'button';
});

const uriPath = computed(() => props.to.split('#')[0]);

const isActive = computed(() => {
  if (props.to) {
    return route.path.includes(uriPath.value);
  }
});
</script>
<style lang="scss" scoped>
.item {
  display: grid;
  grid-template-columns: 15% 1fr;
  align-items: center;
  width: 100%;
  gap: 2rem;
  transition: color 250ms $ease-in-quad;
  &.active,
  &:hover,
  &:focus {
    transition: color 250ms $ease-out-quad;
    color: var(--color_secondary);
  }
  .icon {
    justify-self: center;
  }
}
.infos {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  gap: 0.8rem;
}
.badge-wrapper {
  display: inline-block;
}
</style>
